import { memo } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';
// config
import { HEADER } from '../../../config';
// components
import { NavSectionHorizontal } from '../../../components/nav-section';
//
import navConfig from './NavConfig';
import useAuth from '../../../hooks/useAuth';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  transition: theme.transitions.create('top', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  width: '100%',
  position: 'fixed',
  zIndex: theme.zIndex.appBar,
  padding: theme.spacing(1, 0),
  boxShadow: theme.customShadows.z8,
  top: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------



function NavbarHorizontal() {
  const { user } = useAuth();

  const createRestrictedNav = ( nav ) => {
    if(user.restricted) {
        if(nav?.subheader === 'Analytics' && !user.teamUser.permissions.analytics) return false
    }   
    return nav
  }
  const restrictedNavConfig = navConfig.filter(createRestrictedNav)
  return (
    <RootStyle id="sidebarid">
      <Container maxWidth={false}>
        <NavSectionHorizontal navConfig={restrictedNavConfig} />
      </Container>
    </RootStyle>
  );
}

export default memo(NavbarHorizontal);
